(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PedidoNutricionalFazerController', PedidoNutricionalFazerController);

        PedidoNutricionalFazerController.$inject = ['Pedidonutricional', 'Pedido', 'PedidoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'Propriedade', 'Safra', 'Mapaimagem', 'Maquinario', '$translate', 'Atributo'];

    function PedidoNutricionalFazerController(Pedidonutricional, Pedido, PedidoSearch, ParseLinks, AlertService, paginationConstants, Propriedade, Safra, Mapaimagem, Maquinario, $translate, Atributo) {

        var vm = this;

        vm.carregando = false;

        // Vetores auxiliares
        vm.ultimoIndice = null;

        vm.clickTeste = clickTeste;
        function clickTeste(){
            console.log(vm.mapasSelecionados);
        }

        // Preenchimento dos dados
        vm.filtroPropriedade = null;

        vm.propriedades = Propriedade.queryNomesPropriedades({
            size: 1000,
            sort: "nomepropriedade,asc"
        });

        vm.atributos = Atributo.query({
            size: 1000,
            sort: "nomeatributo,asc"
        });

        vm.filtroSafra = null;

        vm.changeFiltroPropriedade = function () {
            vm.mapasSelecionados = [];
            vm.dadosMapas=[]

            vm.safras = vm.filtroPropriedade ?  Safra.querySafrasPorPropriedade({
                idPropriedade: vm.filtroPropriedade.id,
                size: 1000,
                sort: "nomesafra,asc"
            }) : [] ;   
            
        };

        vm.filtroTipoMapa = null;

        // Auxiliares
        vm.ajustaData = ajustaData;
        function ajustaData(dataString){
            var d = new Date(dataString);
            d.setDate(d.getDate()+1);
            d.setHours(0);
            return d;        
        }

        vm.somadia = somadia;
        function somadia(d, valor){
            var n = new Date(d);
            n.setDate(n.getDate() + valor);
            n.setHours(0);
            return n;
        }

        //Confirmação de pedido
        vm.confirmarPedido = confirmarPedido;
        function confirmarPedido(){

            if(vm.filtroPropriedade == null || vm.filtroPropriedade=="" || vm.filtroSafra == null || vm.filtroSafra == "" || vm.filtroAtributo == null || vm.filtroAtributo == ""){
                alert("Preencha os dados básicos!");
                return;
            }

            if(vm.formuladocomposto == null || vm.formuladocomposto=="" || vm.nomeformulado == null || vm.nomeformulado == "" || vm.porcentagemcomposto == null || vm.porcentagemcomposto == "" || vm.porcentagemacrescimo == "" || vm.porcentagemacrescimo == null){
                alert("Preencha os dados do formulado!");
                return;
            }

            if(vm.crea == null || vm.crea=="" || vm.areatotal == null || vm.areatotal == ""){
                alert("Preencha os dados adicionais!");
                return;
            }

            var pedido = new Pedidonutricional();

            pedido.propriedade = new Propriedade();
            pedido.propriedade.id = vm.filtroPropriedade.id;

            pedido.safra = new Safra();
            pedido.safra.id = vm.filtroSafra.id;

            pedido.nutriente = vm.filtroAtributo.nomeatributo;

            pedido.formuladocomposto = vm.formuladocomposto;

            pedido.nomeformulado = vm.nomeformulado;

            pedido.porcentagemformula = vm.porcentagemcomposto.toString().replace(",", ".") + '%';

            pedido.porcentagemacrescimo = vm.porcentagemacrescimo.toString().replace(",", ".") + '%';

            pedido.status = "aguardando";
            
            pedido.crea = vm.crea;

            pedido.areatotal = vm.areatotal;
            
            pedido.datas = new Date();

            Pedidonutricional.save(pedido);

        }
    }
})();
